import { ApiError } from "../../lib/api";
import { t, type TranslationKey } from "../locale";

/**
 * Visitor-facing text for a failed slotting request.
 *
 * Audit 2026-09-23 (4a): a 401 (anonymous visitor on an appointment /
 * waitlist / booking link) used to surface the Worker's raw English
 * `Unauthorized`. The visitor needs to log in — say so, in their language.
 *
 * Fix round 3 (R2-P2): the Worker's `requireSession` answers a Mongo blip
 * with `503 {error:"Service temporarily unavailable"}` on every slotting
 * handler — same key `submit-error.ts` uses, so one outage reads the same on
 * the register form and the booking widget.
 *
 * Every other ApiError keeps its message; anything else falls back to the
 * caller's generic key.
 */
export function slottingErrorText(err: unknown, fallback: TranslationKey): string {
  if (err instanceof ApiError) {
    if (err.status === 401) return t("slottingLoginRequired");
    if (err.status === 503) return t("errorServiceUnavailable");
    return err.message;
  }
  return t(fallback);
}
